import { noop } from 'lodash';
import { createStateContext } from 'react-use';

export const [useCreateOrgPopoverContext, CreateOrgPopoverContextProvider] = createStateContext<{
  isCreating: boolean;
}>({
  isCreating: false,
});

export const [usePageFormControlsContext, PageFormControlsContextProvider] = createStateContext<{
  showFormControls: boolean;
  onDiscard: () => void;
  onSave: () => void;
}>({
  showFormControls: false,
  onDiscard: noop,
  onSave: noop,
});
